export default __webpack_public_path__ + "static/ruskids-cover-1776cbee85f003adea880ab8707849a7.jpg";